import {IApp} from "@/interfaces/app.interface";

export namespace ITrailer {
  export enum Action {
    Make = 'Trailer_MK',
  }

  export enum Command {
    Get = 'get',
    Set = 'set',
    NoTrailer = 'no_trailer',
    Parking = 'parking',
    Unloading = 'unloading',
    SetCorp = 'setCorp',
  }

  export interface IEntity {
    trailerId: number;
    trailerMovId: number;
    trailerCarNumber: string;

    comment: string;
    corpName: string;
    dateBeg: string;
    hour: string;
    orderby: string;
  }

  export const TableTrailersColumns = [
    { prop: 'trailerCarNumber', label: 'Номер', },
    { prop: 'comment',          label: 'Комментарий', },
    { prop: 'corpName',         label: 'Корпорация', },
    { prop: 'dateBeg',          label: 'Дата заезда', propType: IApp.SortingPropType.Date,  dateFormat: IApp.DateFormats.PrintedDateTimeFull },
    { prop: 'hour',             label: 'Время стоянки', },
  ];
}